import { faceMock } from "../../mocks/face";
import { store } from "../../store";
import {
  NETWORK_WARNINGS_INACTIVE,
  NETWORK_WARNINGS_ACTIVE,
  getFetchConfig,
  handleRawResponse,
  urlAddTenant,
} from ".";
import { PASSPORT } from "../../enums/documentType";
import { delayedPromise } from "../../delayedPromise";
// import { addXMP } from "../../addXMP";

const actionPrefix = "API_";
export const SAVE_DOCUMENT = actionPrefix + "SAVE_DOCUMENT";

/**
 * POST /{tenant}/DigitalOnBoardingServices/rest/v1/users/{userId}/idchecks/{idCheckId}/documents
 */
export const documentsSave = (image1, image2, documentType) => (dispatch) => {
  dispatch({ type: NETWORK_WARNINGS_ACTIVE });
  let promise;
  const documentStore = store.getState().documentCapture;
  const isDocumentSinglePaged = documentStore.singlePaged;

  if (process.env.REACT_APP_MOCK_API === "true") {
    promise = delayedPromise(faceMock);
  } else {
    const request = {
      processingType: "ID",
      captureType: "BBC",
      captured: new Date().toISOString(),
      captureFormat: documentType === PASSPORT ? "PASSPORT" : "ID1",
      clientCapture: {
        images: [
          {
            type: "FRONT",
            sensitiveData: {
              imageFormat: "JPG",
              value: image1,
            },
          },
        ],
      },
    };

    if (documentType !== PASSPORT && isDocumentSinglePaged !== true) {
      request.clientCapture.images.push({
        type: "BACK",
        sensitiveData: {
          imageFormat: "JPG",
          value: image2,
        },
      });
    }

    const { application, configuration } = store.getState();
    const isAsync =
      configuration.extraConfig.featureFlags.asyncDocumentProcessing === "true"
        ? true
        : false;
    const controller = new AbortController();
    const signal = controller.signal;
    setTimeout(() => {
      controller.abort();
    }, 30000);
    promise = fetch(
      urlAddTenant(
        `/DigitalOnBoardingServices/rest/v1/users/${application.user.id}/idchecks/${application.user.idCheck.id}/documents?isAsync=${isAsync}`
      ),
      {
        ...getFetchConfig(),
        method: "POST",
        signal,
        credentials: "same-origin",
        body: JSON.stringify(request),
      }
    ).then(handleRawResponse);
  }
  return promise.then((response) => {
    dispatch({ type: NETWORK_WARNINGS_INACTIVE });
    return response;
  });
};
